module.exports = __webpack_public_path__ + "static/waves-67d68d619d9a213d4b546467b78208fb.png";